import React, { lazy } from "react";
import PrivateRoute from "../../components/PrivateRoute";
import { Routes } from "../../context/App";

const AppUsage = lazy(() => import("../../pages/AppUsage"));

interface AppUsageProps {
  route: typeof Routes.APPUSAGE;
  path: string;
  exact: boolean;
}

const AppUsageRoute: React.FC<AppUsageProps> = (props) => {
  const { route, path, exact } = props;
  return (
    <PrivateRoute
      path={path}
      route={route}
      exact={exact}
      Component={AppUsage}
    />
  );
};

export default AppUsageRoute;
